import pl from "shared/messages/pl";
import { CardEnum } from "container/CardEnum";
import { GrantEnum } from "view360Card/models/GrantEnum";
import { Tab } from "shared/models/Tab";

interface IConstants {
    main: Tab[];
}

export const tabDefinitions = {
    main: [
        {
            key: CardEnum.GoalsCard,
            content: pl.tabs.goalsCard,
            requiredgrant: GrantEnum.ReportScoreCard
        },
        {
            key: CardEnum.Tasks,
            content: pl.tabs.tasks,
            requiredgrant: GrantEnum.Task
        },
        {
            key: CardEnum.MotivationCard,
            content: pl.tabs.motivationCard,
            requiredgrant: GrantEnum.ReportRanking
        },
        {
            key: CardEnum.View360,
            content: pl.tabs.view360,
            requiredgrant: GrantEnum.V360
        },
        {
            key: CardEnum.PowerBiReports,
            content: pl.tabs.powerBiReports,
            requiredgrant: GrantEnum.PowerBi
        },
        {
            key: CardEnum.GlobalNotes,
            content: pl.tabs.globalNotes,
            requiredgrant: GrantEnum.GlobalNotes
        },
        {
            key: CardEnum.RmsPortal,
            content: pl.tabs.rmsPortal,
            requiredgrant: GrantEnum.Sharepoint
        },
        {
            key: CardEnum.UserProfile,
            content: pl.tabs.userProfile,
            requiredgrant: GrantEnum.UserProfile
        },
    ],
} as IConstants;